
import type { App } from 'vue';

import i18next from "i18next";
import I18NextVue from "i18next-vue";;
import { z } from "zod";
import { zodI18nMap } from "zod-i18n-map";
import translation from "zod-i18n-map/locales/nl/zod.json";

export const installI18nPlugin = (app: App) => {
  i18next.init({ resources: { nl: { zod: translation } } });
  app.use(I18NextVue, { i18next });
};


z.setErrorMap(zodI18nMap);

// export configured zod instance
export { z }
